import axios from "axios";
import { toast } from "sonner";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  timeout: 90000,
});

// Portal Inversionista: solo lectura. Las escrituras se cortan aquí (y el backend también responde 403).
export const modoSoloLectura = { activo: false };
api.interceptors.request.use((cfg) => {
  const m = (cfg.method || "get").toLowerCase();
  const url = cfg.url || "";
  if (modoSoloLectura.activo && ["post", "put", "patch", "delete"].includes(m) && !url.startsWith("/auth/") && url !== "/notificaciones/leidas") {
    toast.info("Portal Inversionista: modo solo lectura");
    const err = new Error("solo lectura"); err.response = { status: 403, data: { detail: "Portal Inversionista: modo solo lectura" } }; err.soloLectura = true;
    return Promise.reject(err);
  }
  return cfg;
});

// Sesión: si el access token (12 h) expira, renueva con el refresh token y reintenta una vez; si no se puede, manda a login.
let refrescando = null;
export const onSesionPerdida = { fn: null };
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err?.config || {};
    const url = cfg.url || "";
    if (err?.response?.status === 401 && !cfg._reintentado && !url.includes("/auth/")) {
      cfg._reintentado = true;
      try {
        refrescando = refrescando || axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh`, {}, { withCredentials: true }).finally(() => { refrescando = null; });
        await refrescando;
        return api(cfg);
      } catch {
        if (onSesionPerdida.fn) {
          toast.error("Tu sesión expiró. Vuelve a iniciar sesión.");
          onSesionPerdida.fn();
        }
      }
    }
    if (err?.code === "ECONNABORTED") err.response = { data: { detail: "El servidor tardó demasiado en responder. Intenta de nuevo." } };
    const st = err?.response?.status;
    const cuerpo = err?.response?.data;
    const esHtml = typeof cuerpo === "string" && /<html|cloudflare|<!doctype/i.test(cuerpo);
    if (!err?.response || esHtml || st === 502 || st === 503 || st === 504 || st === 520 || st === 521 || st === 522 || st === 523 || st === 524) {
      err.response = { ...(err.response || {}), status: st || 0, data: { detail: "El servidor se está actualizando o no está disponible por unos segundos. Espera un momento e intenta de nuevo." } };
      err.servidorNoDisponible = true;
    }
    return Promise.reject(err);
  },
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Error inesperado";
  if (typeof detail === "string") return detail;
  if (detail?.mensaje) return detail.mensaje;
  if (Array.isArray(detail)) return detail.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return typeof detail?.msg === "string" ? detail.msg : JSON.stringify(detail);
}

export default api;
